import { useEffect, useState } from "react";
import "../../assets/css/storage/storage.css";
import awsbucket from "../../assets/img/awsbucket.png";
import StorageConfigService from "../../services/api/storageConfig";
import { provisionerTypeLogo } from "../../settings/shared/commonMethods";
import { Button, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormCheck, FormGroup, FormLabel, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "react-bootstrap";
import ProvisionerService from "../../services/api/Provisioner";
import { provisionerService, API_RESPONSE } from "../../settings/shared/constants";
import StorageService from "../../services/api/Storage/index.js";
import RowMenu from "./RowMenu";
import moment from "moment";
import toast from "react-hot-toast";
import LoaderOverlay from "../../components/LoadingOverlay.js";
import Scrollbars from "react-custom-scrollbars";

const StorageConfig = (props) => {
    const [getStorageId, setStorageId] = useState("");
    const [getBucketName, setBucketName] = useState("");
    const [getRootFolder, setRootFolder] = useState("");
    const [getprovisionerType, setprovisionerType] = useState("");
    const [getConfigData, setConfigData] = useState([]);
    const [provisionerNames, setProvisionerNames] = useState([]);
    const [openConfiguration, setopenConfiguration] = useState(props.openConfiguration);
    const [showBucketList, setShowBucketList] = useState(false);
    const [editId, setEditId] = useState("");
    const [errorMessage, seterrorMessage] = useState("");
    const [isStorageStatus, setisStorageStatus] = useState(false);
    const [isStoragePrimary, setisStoragePrimary] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [provisionerId, setProvisionerId] = useState("");
    const [cloudBucketList, setCloudBucketList] = useState([]);
    const [selectedcloudBucketList, setSelectedcloudBucketList] = useState([]);
    const [selectAllFlag, setSelectAllFlag] = useState(false);
    const [getConfigprovisionerType, setConfigprovisionerType] = useState("");
    const [storageConfigName, setStorageConfigName] = useState("");
    const [storageConfigId, setStorageConfigId] = useState("");
    const [deleteConfigModal, setDeleteConfigModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const [bucketSearch, setBucketSearch] = useState("");
    const [connSearch, setConnSearch] = useState("");
    const hasName = name.trim().length > 0;
    const hasProvisioner = !!provisionerId;
    const hasBuckets = selectedcloudBucketList.length > 0;
    const primaryBucket = selectedcloudBucketList.find((b) => b.primary);
    const pickedCount = cloudBucketList.filter((b) => b.chooseBucketFlag).length;
    const visiblePickerList = cloudBucketList
        .map((b, idx) => ({ ...b, _idx: idx }))
        .filter((b) => b.bucketName?.toLowerCase().includes(bucketSearch.trim().toLowerCase()));

     const connQuery = connSearch.trim().toLowerCase();
     const visibleConnections = getConfigData
         .map((item, index) => ({ item, index }))   // keep original index for clickExpandTrue
         .filter(({ item }) =>
             !connQuery ||
             (item.platformDefault ? "default storage" : item.name || "").toLowerCase().includes(connQuery)
         );

    useEffect(() => {
        getAllStorageConfig();
        getProvisionerServices();
        setopenConfiguration(props.openConfiguration);
    }, [props.openConfiguration]);

    const getAllStorageConfig = () => {
        StorageConfigService.getAllStorageConfig()
            .then((response) => {
                if (response?.status === API_RESPONSE.SUCCESS) {
                    let configData = response?.storageDTOPage?.content || [];
                    configArrayModified(configData);
                } else {
                    toast.error(response?.errorMessage);
                }
            }).catch((error) => {
                toast.error(error);
                setLoading(false);
            });
    };

    const configArrayModified = (data) => {
        let platformDefault = data.find(item => item.platformDefault);
        if (platformDefault) {
            let currentUrl = window.location.href;
            let urlParams = new URLSearchParams(currentUrl.substring(currentUrl.indexOf('?') + 1));
            let storageId = urlParams.get('storage');
            let folderPath = urlParams.get('path');
            let rootFolder = urlParams.get('root');

            if (storageId && storageId !== "null") {
                let filter = data.filter(it => it.id === storageId);
                if (filter.length > 0) {
                    setStorageId(storageId);
                    setBucketName(rootFolder);
                    props._getStorageInfo(filter[0], rootFolder, folderPath);
                }
            } else {
                setStorageId(platformDefault.id);
                props._getStorageInfo(platformDefault, null, null);
            }
        }
        const arrWithColor = data.map(object => ({ ...object, expandFlag: false }));
        setConfigData(arrWithColor);
        setLoading(false);
    };

    const getProvisionerServices = () => {
        ProvisionerService.getProvisionerByService(provisionerService.storage)
            .then((response) => {
                if (response.status === API_RESPONSE.SUCCESS) {
                    let contents = response.provisionerDTOPage.content || [];
                    setProvisionerNames(contents.map(c => ({
                        label: `${c.provisionerType} : ${c.name}`,
                        value: c.id
                    })));
                }
            });
    };

    const clickExpandTrue = (index, flag) => {
        setConfigData(prev => prev.map((item, i) => i === index ? { ...item, expandFlag: flag } : item));
    };

    const onStorageNameCickEvent = (item) => {
        window.history.pushState("", "", "/storage");
        setStorageId(item.id);
        setprovisionerType(item.provisionerType);
        if (item.storageConfig === null) {
            setBucketName("");
            setRootFolder("");
            props._getStorageInfo(item, null, null);
        }
    };

    const onStorageConfigEdit = (id) => {
        setopenConfiguration(true);
        setEditId(id);
        StorageConfigService.getAllStorageConfigById(id)
            .then((response) => {
                if (response.status === API_RESPONSE.SUCCESS && response.storageDTOS.length > 0) {
                    let data = response.storageDTOS[0];
                    setName(data.name);
                    setDescription(data.description);
                    setProvisionerId(data.provisionerId);
                    setConfigprovisionerType(data.provisionerType);
                    setisStoragePrimary(data.primary);
                    setisStorageStatus(data.storageStatus === "ENABLED");
                    setSelectedcloudBucketList(data.storageConfig.bucketStorages);
                }
            });
    };

    const onStorageConfigDeleteConfirmation = (id, name) => {
        setStorageConfigName(name);
        setStorageConfigId(id);
        setDeleteConfigModal(true);
    };

    const removeStorageConfig = (rid) => {
        StorageConfigService.deleteStorageConfig(rid)
            .then((response) => {
                if (response.status === API_RESPONSE.SUCCESS) {
                    getAllStorageConfig();
                    setDeleteConfigModal(false);
                    toast.success("Deleted Successfully");
                }
            });
    };

    const onBucketNameCickEvent = (item, bucketData) => {
        window.history.pushState("", "", "/storage");
        setStorageId(item.id);
        setBucketName(bucketData?.bucketName || "");
        setprovisionerType(item.provisionerType);
        setRootFolder(bucketData?.bucketName || null);
        props._getStorageInfo(item, bucketData.bucketName, null);
    };

    const clearStorageConfigModalData = () => {
        setopenConfiguration(false);
        props._toggleopenConfiguration();
        setEditId("");
        setName("");
        setDescription("");
        setProvisionerId("");
        setisStoragePrimary(false);
        setisStorageStatus(false);
        seterrorMessage("");
        setSelectedcloudBucketList([]);
        setShowBucketList(false);
        setCloudBucketList([]);
        setSelectAllFlag(false);
    };

    const applyBucketSelection = () => {
        setSelectedcloudBucketList(cloudBucketList.filter(b => b.chooseBucketFlag));
        setShowBucketList(false);
    };

    const closeBucketPickerWithoutApply = () => {
        setShowBucketList(false);
    };

    const handleProvisioner = (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        setProvisionerId(event.target.value);
        setConfigprovisionerType(selectedOption.text);
        setSelectedcloudBucketList([]);
        setShowBucketList(false);
        setCloudBucketList([]);
        setSelectAllFlag(false);
    };

    const getBucketsList = () => {
        StorageService.getBucketsList(provisionerId)
            .then((response) => {
                if (response?.result) {
                    const temp = response.result.map(bucket => ({
                        bucketName: bucket.name,
                        chooseBucketFlag: selectedcloudBucketList.some(s => s.bucketName === bucket.name),
                        primary: false,
                        readOnly: false,
                        dateCreated: bucket.created
                    }));
                    setCloudBucketList(temp);
                    setSelectAllFlag(temp.every(t => t.chooseBucketFlag));
                }
            });
    };

    const handleChangeBucket = idx => e => {
        const { name, checked } = e.target;
        const newList = [...selectedcloudBucketList];
        if (name === "primary") {
            newList.forEach((item, i) => item.primary = i === idx ? checked : false);
        } else {
            newList[idx][name] = checked;
        }
        setSelectedcloudBucketList(newList);
    };

    const addNewStorageConfig = () => {
        if (!name) return seterrorMessage("Please Enter Name");
        if (!provisionerId) return seterrorMessage("Please Select Provisioner");
        if (selectedcloudBucketList.length === 0) return seterrorMessage("Please select buckets");

        const configData = {
            name,
            accountId: localStorage.getItem("accountId"),
            provisionerId,
            provisionerType: getConfigprovisionerType?.split(":")[0].trim(),
            description,
            primary: isStoragePrimary,
            storageStatus: isStorageStatus ? "ENABLED" : "DISABLED",
            storageConfig: {
                bucketStorages: selectedcloudBucketList.map(({ chooseBucketFlag, dateCreated, ...rest }) => rest),
                storageType: "BUCKET"
            }
        };

        const apiCall = editId 
            ? StorageConfigService.UpdateStorageConfig(editId, configData)
            : StorageConfigService.PostStorageConfiguration(configData);

        apiCall.then((response) => {
            if (response.status === API_RESPONSE.SUCCESS) {
                toast.success(`Storage ${editId ? 'Updated' : 'Created'} Successfully!`);
                clearStorageConfigModalData();
                getAllStorageConfig();
            } else {
                toast.error(response?.errorMessage);
            }
        });
    };

    return (
        <>
            {loading && <LoaderOverlay loading={loading} />}

            <Scrollbars autoHeight autoHeightMin={props?.height - 190} autoHeightMax={props?.height - 190}>
    <div className="sc-connections">
        {/* Search only appears once the list is long enough to need it */}
        {getConfigData.length > 4 && (
            <div className="sc-conn-search">
                <i className="fas fa-search" aria-hidden="true" />
                <input
                    type="text"
                    placeholder="Search connections"
                    aria-label="Search connections"
                    value={connSearch}
                    onChange={(e) => setConnSearch(e.target.value)}
                />
                {connSearch && (
                    <button type="button" aria-label="Clear search" onClick={() => setConnSearch("")}>
                        <i className="fas fa-times" />
                    </button>
                )}
            </div>
        )}
 
        {visibleConnections.length > 0 ? (
            visibleConnections.map(({ item, index }) => {
                const buckets = item.storageConfig?.bucketStorages || [];
                const hasBuckets = buckets.length > 0;
                const isActive = getStorageId === item.id;
                const isDisabled = item.storageStatus === "DISABLED";
                const displayName = item.platformDefault ? "Default Storage" : item.name;
 
                return (
                    <div
                        key={item.id || index}
                        className={`sc-conn-card ${isActive ? "is-active" : ""} ${item.expandFlag && hasBuckets ? "is-open" : ""}`}
                    >
                        <div
                            className={`sc-conn-row ${isActive ? "is-active" : ""} ${isDisabled ? "is-disabled" : ""}`}
                            onClick={() => onStorageNameCickEvent(item)}
                            onKeyDown={(e) => {
                                if (e.target !== e.currentTarget) return; // ignore keys from inner buttons
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    onStorageNameCickEvent(item);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                            aria-pressed={isActive}
                        >
                            <div className="sc-conn-row-inner">
                                {hasBuckets ? (
                                    <button
                                        type="button"
                                        className="sc-conn-chevron"
                                        aria-expanded={!!item.expandFlag}
                                        aria-label={item.expandFlag ? "Collapse buckets" : "Expand buckets"}
                                        title={item.expandFlag ? "Collapse buckets" : "Expand buckets"}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            clickExpandTrue(index, !item.expandFlag);
                                        }}
                                    >
                                        <i className={`fas fa-chevron-right ${item.expandFlag ? "is-rotated" : ""}`} />
                                    </button>
                                ) : (
                                    <span className="sc-conn-chevron-placeholder" aria-hidden="true" />
                                )}
 
                                <div className="sc-conn-icon-wrap">
                                    <img
                                        src={provisionerTypeLogo(item.platformDefault ? undefined : item.provisionerType)}
                                        alt=""
                                        className="sc-conn-icon"
                                    />
                                    <span
                                        className={`sc-conn-status ${isDisabled ? "is-off" : "is-on"}`}
                                        title={isDisabled ? "Disabled" : "Enabled"}
                                    />
                                </div>
 
                                <div className="sc-conn-body">
                                    <span className="sc-conn-name text-truncate" title={displayName}>
                                        {displayName}
                                    </span>
                                    <span className="sc-conn-meta">
                                        {isDisabled && <span className="sc-tag sc-tag-off">Disabled</span>}
                                        {item.platformDefault && <span className="sc-tag sc-tag-default">Built-in</span>}
                                        <span className="sc-conn-count">
                                            {hasBuckets
                                                ? `${buckets.length} ${buckets.length === 1 ? "bucket" : "buckets"}`
                                                : "No buckets"}
                                        </span>
                                    </span>
                                </div>
                            </div>
 
                            {/* Clicks inside the menu (even though it's portalled) never select the row */}
                            <div
                                className="sc-conn-actions"
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) => e.stopPropagation()}
                            >
                                {!item.platformDefault && (
                                    <RowMenu
                                        label={displayName}
                                        onEdit={() => onStorageConfigEdit(item.id)}
                                        onDelete={() => onStorageConfigDeleteConfirmation(item.id, item.name)}
                                    />
                                )}
                            </div>
                        </div>
 
                        {item.expandFlag && hasBuckets && (
                            <div className="sc-conn-buckets" role="list">
                                {buckets.map((bucket, bIdx) => {
                                    const bucketActive = isActive && getBucketName === bucket.bucketName;
                                    return (
                                        <button
                                            type="button"
                                            role="listitem"
                                            key={bIdx}
                                            className={`sc-conn-bucket ${bucketActive ? "is-active" : ""}`}
                                            title={bucket.bucketName}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onBucketNameCickEvent(item, bucket);
                                            }}
                                        >
                                            <i className="fa-brands fa-bitbucket sc-conn-bucket-icon" aria-hidden="true" />
                                            <span className="sc-conn-bucket-name text-truncate">{bucket.bucketName}</span>
                                            {bucket.primary && (
                                                <span className="sc-conn-bucket-primary" title="Primary bucket">
                                                    <i className="fas fa-star" /> Primary
                                                </span>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })
        ) : getConfigData.length > 0 ? (
            <div className="sc-connections-empty">
                <div className="sc-connections-empty-title">No match for “{connSearch}”</div>
                <button type="button" className="sc-link-btn" onClick={() => setConnSearch("")}>
                    Clear search
                </button>
            </div>
        ) : (
            !loading && (
                <div className="sc-connections-empty">
                    <div className="sc-connections-empty-icon">
                        <i className="fas fa-cloud" />
                    </div>
                    <div className="sc-connections-empty-title">No storage connected</div>
                    <div className="sc-connections-empty-text">
                        Add a storage connection to browse its buckets here.
                    </div>
                </div>
            )
        )}
    </div>
</Scrollbars>

            {/* Modal remains consistent but uses denser spacing */}
            <Modal
    className="sc-confirm-modal"
    show={deleteConfigModal}
    onHide={() => setDeleteConfigModal(false)}
    centered
    size="sm"
>
    <ModalBody className="sc-confirm-body">
        <div className="sc-confirm-icon" aria-hidden="true">
            <i className="fas fa-trash" />
        </div>
        <h6 className="sc-confirm-title">Delete this storage?</h6>
        <p className="sc-confirm-text">
            <strong>{storageConfigName}</strong> will be removed from your connections.
        </p>
        <div className="sc-confirm-actions">
            <Button variant="light" size="sm" className="sc-btn" onClick={() => setDeleteConfigModal(false)}>
                Keep it
            </Button>
            <Button variant="danger" size="sm" className="sc-btn" onClick={() => removeStorageConfig(storageConfigId)}>
                Delete storage
            </Button>
        </div>
    </ModalBody>
</Modal>

            <Modal
                className="storage-config-modal"
                show={openConfiguration}
                size="lg"
                onHide={clearStorageConfigModalData}
                centered
                backdrop="static"
                scrollable
            >
                <ModalHeader closeButton className="sc-modal-header">
                    <div className="sc-header-main">
                        <div className="sc-header-icon" aria-hidden="true">
                            <i className="fas fa-cloud" />
                        </div>
                        <div>
                            <div className="sc-modal-title">{editId ? "Edit storage" : "Add storage"}</div>
                            <div className="sc-modal-subtitle">
                                {editId
                                    ? "Update connection details and buckets."
                                    : "Connect a provisioner, then choose the buckets to include."}
                            </div>
                        </div>
                    </div>
                    <div className="sc-header-badges">
                        <span className={`sc-pill ${isStorageStatus ? "sc-pill-on" : "sc-pill-off"}`}>
                            <span className="sc-dot" /> {isStorageStatus ? "Enabled" : "Disabled"}
                        </span>
                        {isStoragePrimary && (
                            <span className="sc-pill sc-pill-primary">
                                <i className="fas fa-star" /> Primary storage
                            </span>
                        )}
                    </div>
                </ModalHeader>

                <ModalBody className="sc-modal-body">
                    {errorMessage && (
                        <div className="sc-alert" role="alert">
                            <i className="fas fa-exclamation-circle" />
                            <span>{errorMessage}</span>
                        </div>
                    )}

                    {/* ───────── Step 1: Basics ───────── */}
                    <section className="sc-step">
                        <header className="sc-step-head">
                            <span className={`sc-step-marker ${hasName ? "is-done" : ""}`}>
                                {hasName ? <i className="fas fa-check" /> : "1"}
                            </span>
                            <div>
                                <h6 className="sc-step-title">Basics</h6>
                                <p className="sc-step-desc">How this storage appears across the app.</p>
                            </div>
                        </header>
                        <Row className="g-3 sc-step-body">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel className="sc-field-label">Display name</FormLabel>
                                    <Form.Control
                                        className="sc-input"
                                        placeholder="e.g. Production S3"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        autoFocus
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel className="sc-field-label">
                                        Description <span className="sc-optional">optional</span>
                                    </FormLabel>
                                    <Form.Control
                                        className="sc-input"
                                        placeholder="Team or environment"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </section>

                    {/* ───────── Step 2: Connection ───────── */}
                    <section className="sc-step">
                        <header className="sc-step-head">
                            <span className={`sc-step-marker ${hasProvisioner ? "is-done" : ""}`}>
                                {hasProvisioner ? <i className="fas fa-check" /> : "2"}
                            </span>
                            <div>
                                <h6 className="sc-step-title">Connection</h6>
                                <p className="sc-step-desc">The provisioner that holds your credentials.</p>
                            </div>
                        </header>
                        <div className="sc-step-body">
                            <FormGroup className="mb-3">
                                <FormLabel className="sc-field-label">Provisioner</FormLabel>
                                <Form.Select className="sc-input" value={provisionerId} onChange={handleProvisioner}>
                                    <option value="">Select a provisioner…</option>
                                    {provisionerNames.map((p, i) => (
                                        <option key={i} value={p.value}>{p.label}</option>
                                    ))}
                                </Form.Select>
                            </FormGroup>

                            <Row className="g-2">
                                <Col sm={6}>
                                    <label className={`sc-toggle ${isStorageStatus ? "is-on" : ""}`}>
                                        <div className="sc-toggle-text">
                                            <span className="sc-toggle-title">Enabled</span>
                                            <span className="sc-toggle-hint">Make this storage available for use</span>
                                        </div>
                                        <FormCheck
                                            type="switch"
                                            id="sc-switch-enabled"
                                            checked={isStorageStatus}
                                            onChange={(e) => setisStorageStatus(e.target.checked)}
                                        />
                                    </label>
                                </Col>
                                <Col sm={6}>
                                    <label className={`sc-toggle ${isStoragePrimary ? "is-on" : ""}`}>
                                        <div className="sc-toggle-text">
                                            <span className="sc-toggle-title">Primary</span>
                                            <span className="sc-toggle-hint">Use as the default storage</span>
                                        </div>
                                        <FormCheck
                                            type="switch"
                                            id="sc-switch-primary"
                                            checked={isStoragePrimary}
                                            onChange={(e) => setisStoragePrimary(e.target.checked)}
                                        />
                                    </label>
                                </Col>
                            </Row>
                        </div>
                    </section>

                    {/* ───────── Step 3: Buckets ───────── */}
                    <section className="sc-step sc-step-last">
                        <header className="sc-step-head">
                            <span className={`sc-step-marker ${hasBuckets ? "is-done" : ""}`}>
                                {hasBuckets ? <i className="fas fa-check" /> : "3"}
                            </span>
                            <div className="flex-grow-1">
                                <h6 className="sc-step-title">Buckets</h6>
                                <p className="sc-step-desc">
                                    {hasBuckets
                                        ? `${selectedcloudBucketList.length} selected${primaryBucket ? ` · primary is ${primaryBucket.bucketName}` : ""}`
                                        : "Choose at least one bucket to save this storage."}
                                </p>
                            </div>
                            <Button
                                variant={showBucketList ? "light" : "outline-primary"}
                                size="sm"
                                className="sc-btn"
                                disabled={!hasProvisioner}
                                title={!hasProvisioner ? "Select a provisioner first" : undefined}
                                onClick={() => {
                                    if (!provisionerId) return toast.error("Select a provisioner first");
                                    setShowBucketList((v) => !v);
                                    if (!showBucketList) getBucketsList();
                                }}
                            >
                                <i className={`fas me-2 ${showBucketList ? "fa-chevron-up" : "fa-plus"}`} />
                                {showBucketList ? "Hide list" : "Choose from account"}
                            </Button>
                        </header>

                        <div className="sc-step-body">
                            {/* Selected buckets */}
                            <div className="sc-bucket-table">
                                {hasBuckets && (
                                    <div className="sc-bucket-row sc-bucket-row-head">
                                        <span>Bucket</span>
                                        <span className="text-center">Primary</span>
                                        <span className="text-center">Read-only</span>
                                        <span />
                                    </div>
                                )}

                                {hasBuckets ? (
                                    selectedcloudBucketList.map((item, idx) => (
                                        <div className={`sc-bucket-row ${item.primary ? "is-primary" : ""}`} key={idx}>
                                            <span className="sc-bucket-name" title={item.bucketName}>
                                                <span className="sc-bucket-icon">
                                                    <img src={awsbucket} width="14" alt="" />
                                                </span>
                                                <span className="text-truncate">{item.bucketName}</span>
                                            </span>
                                            <span className="text-center">
                                                <Form.Check
                                                    type="radio"
                                                    name="primary"
                                                    aria-label={`Make ${item.bucketName} primary`}
                                                    checked={item.primary}
                                                    onChange={handleChangeBucket(idx)}
                                                />
                                            </span>
                                            <span className="text-center">
                                                <Form.Check
                                                    type="checkbox"
                                                    name="readOnly"
                                                    aria-label={`Make ${item.bucketName} read-only`}
                                                    checked={item.readOnly}
                                                    onChange={handleChangeBucket(idx)}
                                                />
                                            </span>
                                            <span className="text-end">
                                                <button
                                                    type="button"
                                                    className="sc-icon-btn"
                                                    aria-label={`Remove ${item.bucketName}`}
                                                    title="Remove"
                                                    onClick={() =>
                                                        setSelectedcloudBucketList((prev) => prev.filter((_, i) => i !== idx))
                                                    }
                                                >
                                                    <i className="fas fa-times" />
                                                </button>
                                            </span>
                                        </div>
                                    ))
                                ) : (
                                    <div className="sc-empty">
                                        <div className="sc-empty-icon"><i className="fas fa-box-open" /></div>
                                        <div className="sc-empty-title">No buckets added</div>
                                        <div className="sc-empty-text">
                                            {hasProvisioner
                                                ? "Select “Choose from account” to pick the buckets you need."
                                                : "Select a provisioner above, then choose your buckets."}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Picker */}
                            {showBucketList && (
                                <div className="sc-picker">
                                    <div className="sc-picker-head">
                                        <div>
                                            <div className="sc-picker-title">Buckets on this provisioner</div>
                                            <div className="sc-picker-sub">
                                                Tick the buckets you want, then apply. Cancel keeps your current list.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="sc-picker-tools">
                                        <div className="sc-search">
                                            <i className="fas fa-search" />
                                            <input
                                                type="text"
                                                placeholder="Search buckets"
                                                value={bucketSearch}
                                                onChange={(e) => setBucketSearch(e.target.value)}
                                            />
                                        </div>
                                        <FormCheck
                                            type="checkbox"
                                            id="sc-select-all"
                                            className="sc-select-all"
                                            label={`Select all${cloudBucketList.length ? ` (${cloudBucketList.length})` : ""}`}
                                            checked={selectAllFlag}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setSelectAllFlag(checked);
                                                setCloudBucketList((prev) => prev.map((b) => ({ ...b, chooseBucketFlag: checked })));
                                            }}
                                        />
                                    </div>

                                    <div className="sc-picker-list">
                                        {cloudBucketList.length === 0 && (
                                            <div className="sc-picker-empty">No buckets found for this provisioner.</div>
                                        )}
                                        {cloudBucketList.length > 0 && visiblePickerList.length === 0 && (
                                            <div className="sc-picker-empty">No buckets match “{bucketSearch}”.</div>
                                        )}
                                        {visiblePickerList.map((item) => (
                                            <label
                                                key={item._idx}
                                                className={`sc-picker-item ${item.chooseBucketFlag ? "is-checked" : ""}`}
                                            >
                                                <FormCheck
                                                    type="checkbox"
                                                    className="no-events"
                                                    checked={!!item.chooseBucketFlag}
                                                    onChange={(e) => {
                                                        const newList = [...cloudBucketList];
                                                        newList[item._idx].chooseBucketFlag = e.target.checked;
                                                        setCloudBucketList(newList);
                                                        setSelectAllFlag(newList.every((n) => n.chooseBucketFlag));
                                                    }}
                                                />
                                                <span className="sc-bucket-icon">
                                                    <img src={awsbucket} width="14" alt="" />
                                                </span>
                                                <span className="sc-picker-name text-truncate">{item.bucketName}</span>
                                                <span className="sc-picker-date">
                                                    {item.dateCreated ? moment(item.dateCreated).format("MMM D, YYYY") : "—"}
                                                </span>
                                            </label>
                                        ))}
                                    </div>

                                    <div className="sc-picker-foot">
                                        <span className="sc-picker-count">{pickedCount} selected</span>
                                        <div className="d-flex gap-2">
                                            <Button variant="light" size="sm" className="sc-btn" onClick={closeBucketPickerWithoutApply}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" size="sm" className="sc-btn" onClick={applyBucketSelection}>
                                                Apply selection
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </ModalBody>

                <ModalFooter className="sc-modal-footer">
                    <div className="sc-footer-note">
                        {hasName && hasProvisioner && hasBuckets ? (
                            <><i className="fas fa-check-circle" /> Ready to save</>
                        ) : (
                            <><i className="far fa-circle" /> Complete all three steps to save</>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <Button variant="light" size="sm" className="sc-btn" onClick={clearStorageConfigModalData}>
                            Cancel
                        </Button>
                        <Button variant="primary" size="sm" className="sc-btn sc-btn-solid" onClick={addNewStorageConfig}>
                            {editId ? "Save changes" : "Create storage"}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>

            <style>{`
                .font9 { font-size: 9px; }
                .font10 { font-size: 10px; }
                .font11 { font-size: 11px; }
                .font12 { font-size: 12px; }
                .font13 { font-size: 13px; }
                .fw-500 { font-weight: 500; }
                .fw-600 { font-weight: 600; }
                .no-caret::after { display: none !important; }
                .btn-xs { padding: 0; line-height: 1; border: none; }
                .max-w-150 { max-width: 150px; }
                .hover-danger:hover { color: #dc3545 !important; }
            `}</style>
        </>
    );
};

export default StorageConfig;